<template>
  <section>
    <validation-observer ref="notifiationForm" #default="{ invalid }">
      <b-form @submit.prevent="submit">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <!-- Field: To -->
              <div class="compose-mail-form-field">
                <div class="p-1 w-100">
                  <div class="d-flex flex-wrap">
                    <b-col cols="12" lg="6">
                      <b-form-group label="نوع پیام">
                        <v-select
                          v-model="notificationType"
                          item-text="label"
                          :options="notificationTypes"
                        />
                      </b-form-group>
                    </b-col>

                    <div class="d-flex flex-wrap w-100">
                      <!-- <b-form-group
                        label="ارسال بر اساس"
                        class="mb-1 col-lg-6 col-12"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="auditable_type"
                          vid="auditable_type"
                          rules="required"
                        >
                          <select-box
                            id="auditable_type"
                            v-model="auditable_type"
                            label="text"
                            class="w-100"
                            select="val"
                            :lists="types"
                            multiple
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group> -->
                      <b-form-group
                        v-if="
                          notificationType &&
                          Object.keys(notificationType) &&
                          notificationType.variable.includes('semesterId')
                        "
                        class="mb-1 col-lg-6 col-12"
                        label="انتخاب ترم"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="semesterId"
                          vid="semesterId"
                          rules=""
                        >
                          <select-box
                            id="semesterId"
                            v-model="semesterId"
                            label="text"
                            class="w-100"
                            select="id"
                            url="semester"
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                      <b-form-group
                        v-if="
                          notificationType &&
                          Object.keys(notificationType) &&
                          notificationType.variable.includes('courseId')
                        "
                        class="mb-1 col-lg-6 col-12"
                        label="انتخاب دوره"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="courseId"
                          vid="courseId"
                          rules=""
                        >
                          <select-box
                            id="courseId"
                            v-model="courseId"
                            label="text"
                            class="w-100"
                            select="id"
                            url="course"
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>

                      <b-form-group
                        v-if="
                          notificationType &&
                          Object.keys(notificationType) &&
                          notificationType.variable.includes('exerciseId')
                        "
                        class="mb-1 col-lg-6 col-12"
                        label="انتخاب تمرین"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="exerciseId"
                          vid="exerciseId"
                          rules=""
                        >
                          <select-box
                            id="exerciseId"
                            v-model="exerciseId"
                            label="text"
                            class="w-100"
                            select="id"
                            url="exercise"
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                      <b-form-group
                        v-if="
                          notificationType &&
                          Object.keys(notificationType) &&
                          notificationType.variable.includes('sessionId')
                        "
                        class="mb-1 col-lg-6 col-12"
                        label="انتخاب جلسه"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="sessionId"
                          vid="sessionId"
                          rules=""
                        >
                          <select-box
                            id="sessionId"
                            v-model="sessionId"
                            label="text"
                            class="w-100"
                            select="id"
                            url="session"
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                      <!-- <b-form-group
                        v-if="
                          notificationType &&
                          Object.keys(notificationType) &&
                          notificationType.variable.includes('penaltyId')
                        "
                        class="mb-1 col-lg-6 col-12"
                        label="انتخاب جریمه"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="penaltyId"
                          vid="penaltyId"
                          rules=""
                        >
                          <select-box
                            id="penaltyId"
                            v-model="penaltyId"
                            label="text"
                            class="w-100"
                            select="id"
                            url=" "
                            searchable
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group> -->
                    </div>
                    <!-- Field: Subject -->
                    <b-col cols="12" lg="6">
                      <b-form-group label="موضوع*">
                        <validation-provider
                          #default="{ errors }"
                          name="email-subject"
                          vid="email-subject"
                          rules="required"
                          label=""
                        >
                          <b-form-input
                            id="email-subject"
                            v-model="subject"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- Field: adminNotify -->
                    <div class="col-md-12 col-12 mb-1">
                      <div class="compose-mail-form-field">
                        <b-form-group label="پیام به ادمین">
                          <validation-provider
                            #default="{ errors }"
                            name="admin-notify"
                            vid="admin-notify"
                            rules=""
                          >
                            <b-form-input
                              id="admin-notify"
                              v-model="admin_notify"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </div>
                    </div>
                    <!-- Field: userNotify -->
                    <div class="col-md-12 col-12 mb-1">
                      <div class="compose-mail-form-field">
                        <b-form-group label="پیام به کاربر">
                          <validation-provider
                            #default="{ errors }"
                            name="user-notify"
                            vid="user-notify"
                            rules=""
                          >
                            <b-form-input
                              id="user-notify"
                              v-model="user_notify"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </div>
                    </div>

                    <div
                      class="col-md-12 col-12 mb-1"
                      v-if="notificationType && Object.keys(notificationType)"
                    >
                      از متغیر های زیر در متن پیام میتوانید استفاده کنید.
                      <br />
                      <b-badge
                        v-for="(
                          value, name, index
                        ) in notificationType.atribiute"
                        :key="index"
                        class="mr-1 my-50 p-1"
                        style="color: rgb(157 157 157)"
                        variant="light"
                      >
                        {{ name }} -
                        {{ value }}
                      </b-badge>
                    </div>

                    <!-- Field: OPERATOR -->
                    <div
                      class="col-md-6 col-12 mb-1"
                      v-if="
                        notificationType &&
                        Object.keys(notificationType) &&
                        notificationType.variable.includes('operator')
                      "
                    >
                      <b-form-group class="w-100" label="اپراتور">
                        <validation-provider
                          #default="{ errors }"
                          name="operator"
                          vid="operator"
                          rules=""
                          ><v-select
                            id="operator"
                            v-model="operator"
                            :options="operators"
                            label="label"
                            select="operator"
                            place-holder="text"
                            :reduce="(item) => item.value"
                            :state="errors.length > 0 ? false : null"
                          />

                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>

                    <!-- Field: time -->
                    <div
                      class="col-md-6 col-12 mb-1"
                      v-if="
                        notificationType &&
                        Object.keys(notificationType) &&
                        notificationType.variable.includes('time') &&
                        operator
                      "
                    >
                      <div class="compose-mail-form-field">
                        <b-form-group class="w-100" label="زمان(روز)">
                          <validation-provider
                            #default="{ errors }"
                            name="time"
                            vid="time"
                            rules="positive"
                          >
                            <b-form-input
                              label="زمان"
                              type="number"
                              id="time"
                              v-model="time"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="compose-mail-form-field py-1 d-flex justify-content-start flex-wrap"
              >
                <label class="col-sm-2 col-12 pt-50">ارسال با: </label>
                <div class="col-10 d-flex flex-wrap">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="sms"
                      :uncheckedValue="0"
                      :value="1"
                      switch
                      inline
                    >
                      پیامک
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                      v-model="email"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      ایمیل
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                      v-model="is_active"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      فعال
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش پیام" : "ایجاد پیام" }}
              </b-button>

              <b-button
                :to="{ name: 'notifications' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست پیام ها
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormInput,
  BAvatar,
  BDropdownDivider,
  BButton,
  BFormGroup,
  BSpinner,
  BFormCheckbox,
  BCard,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Editor from "@core/components/editor/Editor.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, positive } from "@validations";
import notificationTypes from "./NotificationTypes.js";
import Loader from "@/@core/components/loader/Loader.vue";
export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    vSelect,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormInput,
    BAvatar,
    BDropdownDivider,
    BButton,
    BFormCheckbox,
    // 3rd Party
    Editor,
    SelectBox,
    BFormGroup,
    BSpinner,
    BCard,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  data() {
    return {
      loading: false,
      notification: {},
      admin_notify: "",
      user_notify: "",
      subject: "",
      is_active: 0,
      sms: 0,
      email: 0,
      time: "",
      courseId: "",
      semesterId: "",
      exerciseId: "",
      sessionId: "",
      operator: "",
      formsubmit: {},
      notificationType: "",
      notificationTypes: notificationTypes,
      operators: [
        { label: "قبل", value: "BEFORE" },
        { label: "بعد", value: "AFTER" },
        { label: "مساوی", value: "EQUAL" },
      ],
      required,
      positive,
    };
  },
  computed: {
    formFields() {
      return {
        subject: this.subject,
        user_notify: this.user_notify,
        admin_notify: this.admin_notify,
        time: this.time,
        is_active: this.is_active,
        operator: this.operator,
        sms: this.sms,
        email: this.email,
        type:
          this.notificationType &&
          this.notificationType.value &&
          this.notificationType.value,
      };
    },
  },
  watch: {
    formFields(newVal, oldVal) {
      let formsubmit = {};
      if (!newVal.type || (oldVal.type && newVal.type !== oldVal.type)) {
        this.courseId = "";
        this.exerciseId = "";
        this.semesterId = "";
        this.sessionId = "";
        this.operator = "";
        this.time = "";
      }
      newVal.subject && (formsubmit.subject = newVal.subject);
      newVal.user_notify && (formsubmit.user_notify = newVal.user_notify);
      newVal.admin_notify && (formsubmit.admin_notify = newVal.admin_notify);
      newVal.time && (formsubmit.time = newVal.time);
      newVal.operator && (formsubmit.operator = newVal.operator);
      newVal.type && (formsubmit.type = newVal.type);
      formsubmit.sms = newVal.sms;
      formsubmit.email = newVal.email;
      formsubmit.is_active = newVal.is_active;

      this.formsubmit = formsubmit;
    },
  },
  created() {
    if (this.$route.params.id) {
      this.getNotification();
    }
  },
  methods: {
    async getNotification() {
      const { data } = await this.$http.get(
        `panel/system-notifications/${this.$route.params.id}`
      );
      this.notification = data.data;

      this.subject = this.notification.subject;
      this.user_notify = this.notification.user_notify;
      this.admin_notify = this.notification.admin_notify;
      this.is_active = this.notification.is_active ? 1 : 0;
      this.sms = this.notification.sms ? 1 : 0;
      this.email = this.notification.email ? 1 : 0;
      this.operator = this.notification.operator;
      this.time = this.notification.time;

      this.semesterId =
        this.notification.variable &&
        this.notification.variable.semester_id &&
        this.notification.variable.semester_id;

      this.courseId =
        this.notification.variable &&
        this.notification.variable.course_id &&
        this.notification.variable.course_id;

      this.sessionId =
        this.notification.variable &&
        this.notification.variable.session_id &&
        this.notification.variable.session_id;

      this.exerciseId =
        this.notification.variable &&
        this.notification.variable.exercise_id &&
        this.notification.variable.exercise_id;

      this.notificationType = this.notificationTypes.find(
        (item) => item.value === this.notification.type
      );
    },

    async submit() {
      this.$refs.notifiationForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;

          try {
            let variable = {};
            this.semesterId &&
              (this.semesterId.length
                ? (variable.semester_id = this.semesterId[0])
                : (variable.semester_id = this.semesterId));

            this.courseId &&
              (this.courseId.length
                ? (variable.course_id = this.courseId[0])
                : (variable.course_id = this.courseId));

            this.sessionId &&
              (this.sessionId.length
                ? (variable.session_id = this.sessionId[0])
                : (variable.session_id = this.sessionId));

            this.exerciseId &&
              (this.exerciseId.length
                ? (variable.exercise_id = this.exerciseId[0])
                : (variable.exercise_id = this.exerciseId));

            let formData = {
              ...this.formsubmit,
              variable,
            };

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/system-notifications/${this.$route.params.id}?_method=patch`,
                formData
              );
            } else {
              const { data } = await this.$http.post(
                `/panel/system-notifications/`,
                formData
              );
            }
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `پیام شما با موفقیت ارسال شد`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
            setTimeout(() => {
              this.$router.push({ name: "notifications" });
            }, 1000);
          } catch (err) {}

          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
